import { Pagination, Stack } from "@mui/material"

type PaginationButtonsProps = {
    count?: any
    totalPage?: number // Add this line
    onChange: any
    page: number
    paginationPosition?: "center" | "right"
}

export default function PaginationButtons({
    onChange,
    totalPage = 1,
    page,
    paginationPosition = "center",
}: PaginationButtonsProps): JSX.Element {
    const position = paginationPosition === "center" ? "justify-center" : "flex justify-end"

    return (
        <div className={`flex ${position}`}>
            <div className="flex justify-center p-1 space-x-1 rounded-lg">
                <Stack spacing={2}>
                    {totalPage > 1 && (
                        <Pagination
                            count={totalPage}
                            shape="rounded"
                            page={page}
                            onChange={(e, page: number) => onChange(page)}
                            sx={{
                                ".Mui-selected": {
                                    backgroundColor: "rgba(38, 165, 255, 0.16)",
                                    color: "#ff8c3f",
                                },
                                ".Mui-selected:hover": {
                                    backgroundColor: "rgba(38, 165, 255, 0.8)",
                                    color: "#fff",
                                },
                            }}
                        />
                    )}
                </Stack>
            </div>
        </div>
    )
}
